const schedule = {
  "01-01": { nt: "Matt. 1:1-1:25", ot: "Gen. 1:1-2:25" },
  "01-02": { nt: "Matt. 2:1-2:23", ot: "Gen. 3:1-5:32" },
  "01-03": { nt: "Matt. 3:1-3:17", ot: "Gen. 6:1-8:22" },
  "01-04": { nt: "Matt. 4:1-4:25", ot: "Gen. 9:1-11:9" },
  "01-05": { nt: "Matt. 5:1-5:16", ot: "Gen. 11:10-13:18" },
  "01-06": { nt: "Matt. 5:17-5:48", ot: "Gen. 14:1-16:16" },
  "01-07": { nt: "Matt. 6:1-6:34", ot: "Gen. 17:1-18:33" },
  "01-08": { nt: "Matt. 7:1-7:29", ot: "Gen. 19:1-20:18" },
  "01-09": { nt: "Matt. 8:1-8:17", ot: "Gen. 21:1-23:20" },
  "01-10": { nt: "Matt. 8:18-9:8", ot: "Gen. 24:1-25:18" },
  "01-11": { nt: "Matt. 9:9-9:34", ot: "Gen. 25:19-27:27" },
  "01-12": { nt: "Matt. 9:35-10:15", ot: "Gen. 27:28-29:30" },
  "01-13": { nt: "Matt. 10:16-11:1", ot: "Gen. 29:31-31:55" },
  "01-14": { nt: "Matt. 11:2-11:30", ot: "Gen. 32:1-34:31" },
  "01-15": { nt: "Matt. 12:1-12:21", ot: "Gen. 35:1-36:43" },
  "01-16": { nt: "Matt. 12:22-12:50", ot: "Gen. 37:1-38:30" },
  "01-17": { nt: "Matt. 13:1-13:30", ot: "Gen. 39:1-41:13" },
  "01-18": { nt: "Matt. 13:31-13:52", ot: "Gen. 41:14-42:38" },
  "01-19": { nt: "Matt. 13:53-14:13", ot: "Gen. 43:1-44:34" },
  "01-20": { nt: "Matt. 14:14-14:36", ot: "Gen. 45:1-46:34" },
  "01-21": { nt: "Matt. 15:1-15:28", ot: "Gen. 47:1-48:22" },
  "01-22": { nt: "Matt. 15:29-16:12", ot: "Gen. 49:1-50:26" },
  "01-23": { nt: "Matt. 16:13-16:27", ot: "Exo. 1:1-3:22" },
  "01-24": { nt: "Matt. 16:28-17:27", ot: "Exo. 4:1-7:7" },
  "01-25": { nt: "Matt. 18:1-18:35", ot: "Exo. 7:8-8:19" },
  "01-26": { nt: "Matt. 19:1-19:15", ot: "Exo. 8:20-10:29" },
  "01-27": { nt: "Matt. 19:16-20:16", ot: "Exo. 11:1-13:22" },
  "01-28": { nt: "Matt. 20:17-21:11", ot: "Exo. 14:1-15:21" },
  "01-29": { nt: "Matt. 21:12-21:22", ot: "Exo. 15:22-18:27" },
  "01-30": { nt: "Matt. 21:23-21:46", ot: "Exo. 19:1-21:6" },
  "01-31": { nt: "Matt. 22:1-22:14", ot: "Exo. 21:7-23:33" },
  "02-01": { nt: "Matt. 22:15-22:46", ot: "Exo. 24:1-26:30" },
  "02-02": { nt: "Matt. 23:1-23:39", ot: "Exo. 26:31-28:43" },
  "02-03": { nt: "Matt. 24:1-24:31", ot: "Exo. 29:1-30:38" },
  "02-04": { nt: "Matt. 24:32-24:51", ot: "Exo. 31:1-33:23" },
  "02-05": { nt: "Matt. 25:1-25:30", ot: "Exo. 34:1-36:7" },
  "02-06": { nt: "Matt. 25:31-25:46", ot: "Exo. 36:8-38:8" },
  "02-07": { nt: "Matt. 26:1-26:30", ot: "Exo. 38:9-39:43" },
  "02-08": { nt: "Matt. 26:31-26:56", ot: "Exo. 40:1-40:38" },
  "02-09": { nt: "Matt. 26:57-26:75", ot: "Lev. 1:1-3:17" },
  "02-10": { nt: "Matt. 27:1-27:26", ot: "Lev. 4:1-6:7" },
  "02-11": { nt: "Matt. 27:27-27:56", ot: "Lev. 6:8-7:38" },
  "02-12": { nt: "Matt. 27:57-27:66", ot: "Lev. 8:1-10:20" },
  "02-13": { nt: "Matt. 28:1-28:20", ot: "Lev. 11:1-12:8" },
  "02-14": { nt: "Mark 1:1-1:13", ot: "Lev. 13:1-13:59" },
  "02-15": { nt: "Mark 1:14-1:22", ot: "Lev. 14:1-14:57" },
  "02-16": { nt: "Mark 1:23-1:45", ot: "Lev. 15:1-17:16" },
  "02-17": { nt: "Mark 2:1-3:6", ot: "Lev. 18:1-20:27" },
  "02-18": { nt: "Mark 3:7-3:35", ot: "Lev. 21:1-22:33" },
  "02-19": { nt: "Mark 4:1-20", ot: "Lev. 23:1-24:23" },
  "02-20": { nt: "Mark 4:21-34", ot: "Lev. 25:1-26:13" },
  "02-21": { nt: "Mark 4:35-5:20", ot: "Lev. 26:14-27:34" },
  "02-22": { nt: "Mark 5:21-43", ot: "Num. 1:1-2:34" },
  "02-23": { nt: "Mark 6:1-29", ot: "Num. 3:1-4:49" },
  "02-24": { nt: "Mark 6:30-56", ot: "Num. 5:1-6:27" },
  "02-25": { nt: "Mark 7:1-30", ot: "Num. 7:1-89" },
  "02-26": { nt: "Mark 7:31-8:26", ot: "Num. 8:1-10:10" },
  "02-27": { nt: "Mark 8:27-9:13", ot: "Num. 10:11-12:16" },
  "02-28": { nt: "Mark 9:14-9:32", ot: "Num. 13:1-14:45" },
  "03-01": { nt: "Mark 9:33-9:50", ot: "Num. 15:1-16:50" },
  "03-02": { nt: "Mark 10:1-10:31", ot: "Num. 17:1-19:22" },
  "03-03": { nt: "Mark 10:32-10:51", ot: "Num. 20:1-21:20" },
  "03-04": { nt: "Mark 11:1-11:26", ot: "Num. 21:21-22:41" },
  "03-05": { nt: "Mark 11:27-12:17", ot: "Num. 23:1-25:18" },
  "03-06": { nt: "Mark 12:18-12:44", ot: "Num. 26:1-26:65" },
  "03-07": { nt: "Mark 13:1-13:37", ot: "Num. 27:1-28:31" },
  "03-08": { nt: "Mark 14:1-14:26", ot: "Num. 29:1-30:16" },
  "03-09": { nt: "Mark 14:27-14:42", ot: "Num. 31:1-31:54" },
  "03-10": { nt: "Mark 14:43-14:52", ot: "Num. 32:1-32:42" },
  "03-11": { nt: "Mark 14:53-14:72", ot: "Num. 33:1-34:29" },
  "03-12": { nt: "Mark 15:1-15:15", ot: "Num. 35:1-36:13" },
  "03-13": { nt: "Mark 15:16-15:47", ot: "Deut. 1:1-2:23" },
  "03-14": { nt: "Mark 16:1-16:20", ot: "Deut. 2:23-4:43" },
  "03-15": { nt: "Luke 1:1-1:25", ot: "Deut. 4:44-7:8" },
  "03-16": { nt: "Luke 1:26-1:56", ot: "Deut. 7:9-10:11" },
  "03-17": { nt: "Luke 1:57-1:80", ot: "Deut. 10:12-11:32" },
  "03-18": { nt: "Luke 2:1-2:20", ot: "Deut. 12:1-13:18" },
  "03-19": { nt: "Luke 2:21-2:52", ot: "Duet. 14:1-16:22" },
  "03-20": { nt: "Luke 3:1-3:22", ot: "Deut. 17:1-19:21" },
  "03-21": { nt: "Luke 3:23-3:38", ot: "Deut. 20:1-22:12" },
  "03-22": { nt: "Luke 4:1-4:13", ot: "Deut. 22:13-24:22" },
  "03-23": { nt: "Luke 4:14-4:30", ot: "Deut. 25:1-28:14" },
  "03-24": { nt: "Luke 4:31-4:44", ot: "Deut. 28:15-29:17" },
  "03-25": { nt: "Luke 5:1-5:16", ot: "Deut. 29:18-31:30" },
  "03-26": { nt: "Luke 5:17-5:39", ot: "Duet. 31:30-32:47" },
  "03-27": { nt: "Luke 6:1-6:11", ot: "Duet. 32:48-34:12" },
  "03-28": { nt: "Luke 6:12-6:49", ot: "Josh. 1:1-2:24" },
  "03-29": { nt: "Luke 7:1-7:17", ot: "Josh. 3:1-4:24" },
  "03-30": { nt: "Luke 7:18-7:50", ot: "Josh. 5:1-6:27" },
  "03-31": { nt: "Luke 8:1-8:25", ot: "Josh. 7:1-8:35" },
  "04-01": { nt: "Luke 8:26-8:56", ot: "Josh. 9:1-10:27" },
  "04-02": { nt: "Luke 9:1-9:17", ot: "Josh. 10:28-12:24" },
  "04-03": { nt: "Luke 9:18-9:36", ot: "Josh. 13:1-14:5" },
  "04-04": { nt: "Luke 9:37-9:50", ot: "Josh. 14:6-15:63" },
  "04-05": { nt: "Luke 9:51-9:62", ot: "Josh. 16:1-18:28" },
  "04-06": { nt: "Luke 10:1-10:24", ot: "Josh. 19:1-20:9" },
  "04-07": { nt: "Luke 10:25-10:37", ot: "Josh. 21:1-22:34" },
  "04-08": { nt: "Luke 10:38-11:13", ot: "Josh. 23:1-24:33" },
  "04-09": { nt: "Luke 11:14-11:32", ot: "Judg. 1:1-3:6" },
  "04-10": { nt: "Luke 11:33-11:54", ot: "Judg. 3:7-5:31" },
  "04-11": { nt: "Luke 12:1-12:34", ot: "Judg. 6:1-8:32" },
  "04-12": { nt: "Luke 12:35-12:48", ot: "Judg. 8:33-10:5" },
  "04-13": { nt: "Luke 12:49-12:59", ot: "Judg. 10:6-12:15" },
  "04-14": { nt: "Luke 13:1-13:21", ot: "Judg. 13:1-16:31" },
  "04-15": { nt: "Luke 13:22-13:35", ot: "Judg. 17:1-18:31" },
  "04-16": { nt: "Luke 14:1-14:14", ot: "Judg. 19:1-19:30" },
  "04-17": { nt: "Luke 14:15-14:35", ot: "Judg. 20:1-21:25" },
  "04-18": { nt: "Luke 15:1-15:32", ot: "Ruth 1:1-2:23" },
  "04-19": { nt: "Luke 16:1-16:18", ot: "Ruth 3:1-4:22" },
  "04-20": { nt: "Luke 16:19-17:10", ot: "1 Sam. 1:1-2:26" },
  "04-21": { nt: "Luke 17:11-17:37", ot: "1 Sam. 2:27-3:21" },
  "04-22": { nt: "Luke 18:1-18:30", ot: "1 Sam. 4:1-7:17" },
  "04-23": { nt: "Luke 18:31-18:43", ot: "1 Sam. 8:1-10:27" },
  "04-24": { nt: "Luke 19:1-19:27", ot: "1 Sam. 11:1-12:25" },
  "04-25": { nt: "Luke 19:28-19:48", ot: "1 Sam. 13:1-14:52" },
  "04-26": { nt: "Luke 20:1-20:19", ot: "1 Sam. 15:1-15:35" },
  "04-27": { nt: "Luke 20:20-21:4", ot: "1 Sam. 16:1-17:58" },
  "04-28": { nt: "Luke 21:5-21:36", ot: "1 Sam. 18:1-20:42" },
  "04-29": { nt: "Luke 21:37-22:23", ot: "1 Sam. 21:1-23:28" },
  "04-30": { nt: "Luke 22:24-22:46", ot: "1 Sam. 23:29-26:25" },
  "05-01": { nt: "Luke 22:47-22:71", ot: "1 Sam. 27:1-31:13" },
  "05-02": { nt: "Luke 23:1-23:25", ot: "2 Sam. 1:1-4:12" },
  "05-03": { nt: "Luke 23:26-23:56", ot: "2 Sam. 5:1-7:29" },
  "05-04": { nt: "Luke 24:1-24:12", ot: "2 Sam. 8:1-10:19" },
  "05-05": { nt: "Luke 24:13-24:35", ot: "2 Sam. 11:1-12:31" },
  "05-06": { nt: "Luke 24:36-24:53", ot: "2 Sam. 13:1-14:33" },
  "05-07": { nt: "John 1:1-1:18", ot: "2 Sam. 15:1-19:8" },
  "05-08": { nt: "John 1:19-1:51", ot: "2 Sam. 19:9-20:26" },
  "05-09": { nt: "John 2:1-2:22", ot: "2 Sam. 21:1-23:7" },
  "05-10": { nt: "John 2:23-3:13", ot: "2 Sam. 23:8-24:25" },
  "05-11": { nt: "John 3:14-3:36", ot: "1 King 1:1-1:53" },
  "05-12": { nt: "John 4:1-4:14", ot: "1 King 2:1-2:46" },
  "05-13": { nt: "John 4:15-4:26", ot: "1 King 3:1-4:19" },
  "05-14": { nt: "John 4:27-4:54", ot: "1 King 4:20-6:38" },
  "05-15": { nt: "John 5:1-5:16", ot: "1 King 7:1-7:51" },
  "05-16": { nt: "John 5:17-5:47", ot: "1 King 8:1-8:66" },
  "05-17": { nt: "John 6:1-6:21", ot: "1 King 9:1-10:29" },
  "05-18": { nt: "John 6:22-6:31", ot: "1 King 11:1-11:43" },
  "05-19": { nt: "John 6:32-6:71", ot: "1 King 11:44-13:32" },
  "05-20": { nt: "John 7:1-7:36", ot: "1 King 13:33-14:31" },
  "05-21": { nt: "John 7:37-7:52", ot: "1 King 15:1-16:34" },
  "05-22": { nt: "John 7:53-8:36", ot: "1 King 17:1-18:16" },
  "05-23": { nt: "John 8:37-8:59", ot: "1 King 18:17-19:21" },
  "05-24": { nt: "John 9:1-9:13", ot: "1 King 20:1-21:29" },
  "05-25": { nt: "John 9:14-9:41", ot: "1 King 22:1-22:50" },
  "05-26": { nt: "John 10:1-10:21", ot: "1 King 22:51-2 King 2:18" },
  "05-27": { nt: "John 10:22-10:42", ot: "2 King 2:19-4:17" },
  "05-28": { nt: "John 11:1-11:40", ot: "2 King 4:18-6:7" },
  "05-29": { nt: "John 11:41-11:57", ot: "2 King 6:8-8:29" },
  "05-30": { nt: "John 12:1-12:36", ot: "2 King 9:1-10:36" },
  "05-31": { nt: "John 12:37-12:50", ot: "2 King 11:1-12:21" },
  "06-01": { nt: "John 13:1-13:17", ot: "2 King 13:1-15:22" },
  "06-02": { nt: "John 13:18-13:38", ot: "2 King 15:23 - 17:41" },
  "06-03": { nt: "John 14:1-14:31", ot: "2 King 18:1-19:37" },
  "06-04": { nt: "John 15:1-16:4", ot: "2 King 20:1-21:26" },
  "06-05": { nt: "John 16:5-16:33", ot: "2 King 22:1-23:30" },
  "06-06": { nt: "John 17:1-17:26", ot: "2 King 23:31-25:30" },
  "06-07": { nt: "John 18:1-18:38", ot: "1 Chron. 1:1-2:2" },
  "06-08": { nt: "John 18:39-19:16", ot: "1 Chron. 2:3-4:23" },
  "06-09": { nt: "John 19:17-19:42", ot: "1 Chron. 4:24-5:26" },
  "06-10": { nt: "John 20:1-20:31", ot: "1 Chron. 6:1-6:81" },
  "06-11": { nt: "John 21:1-21:25", ot: "1 Chron. 7:1-8:40" },
  "06-12": { nt: "Acts 1:1-1:14", ot: "1 Chron. 9:1-10:14" },
  "06-13": { nt: "Acts 1:15-1:26", ot: "1 Chron. 11:1-12:40" },
  "06-14": { nt: "Acts 2:1-2:13", ot: "1 Chron. 13:1-16:43" },
  "06-15": { nt: "Acts 2:14-2:47", ot: "1 Chron. 17:1-18:17" },
  "06-16": { nt: "Acts 3:1-3:26", ot: "1 Chron. 19:1-21:30" },
  "06-17": { nt: "Acts 4:1-4:12", ot: "1 Chron. 22:1-24:31" },
  "06-18": { nt: "Acts 4:13-4:31", ot: "1 Chron. 25:1-26:32" },
  "06-19": { nt: "Acts 4:32-5:11", ot: "1 Chron. 27:1-27:34" },
  "06-20": { nt: "Acts 5:12-5:32", ot: "1 Chron. 28:1-29:30" },
  "06-21": { nt: "Acts 5:33-5:42", ot: "2 Chron. 1:1-5:1" },
  "06-22": { nt: "Acts 6:1-7:1", ot: "2 Chron. 5:2-7:10" },
  "06-23": { nt: "Acts 7:2-7:53", ot: "2 Chron. 7:11-9:31" },
  "06-24": { nt: "Acts 7:54-8:3", ot: "2 Chron. 10:1-12:16" },
  "06-25": { nt: "Acts 8:4-8:25", ot: "2 Chron. 13:1-16:14" },
  "06-26": { nt: "Acts 8:26-8:40", ot: "2 Chron. 17:1-21:1" },
  "06-27": { nt: "Acts 9:1-9:30", ot: "2 Chron. 21:2-22:9" },
  "06-28": { nt: "Acts 9:31-9:43", ot: "2 Chron. 22:10-24:27" },
  "06-29": { nt: "Acts 10:1-10:16", ot: "2 Chron. 25:1-25:28" },
  "06-30": { nt: "Acts 10:17-10:48", ot: "2 Chron. 26:1-28:27" },
  "07-01": { nt: "Acts 11:1-11:18", ot: "2 Chron. 29:1-31:1" },
  "07-02": { nt: "Acts 11:19-11:30", ot: "2 Chron. 31:2-32:33" },
  "07-03": { nt: "Acts 12:1-12:24", ot: "2 Chron. 33:1-35:27" },
  "07-04": { nt: "Acts 12:25-13:12", ot: "2 Chron. 36:1-36:23" },
  "07-05": { nt: "Acts 13:13-13:52", ot: "Ezra 1:1-2:70" },
  "07-06": { nt: "Acts 14:1-14:28", ot: "Ezra 3:1-4:24" },
  "07-07": { nt: "Acts 15:1-15:34", ot: "Ezra 5:1-6:22" },
  "07-08": { nt: "Acts 15:35-16:18", ot: "Ezra 7:1-8:36" },
  "07-09": { nt: "Acts 16:19-16:40", ot: "Ezra 9:1-10:44" },
  "07-10": { nt: "Acts 17:1-17:34", ot: "Neh. 1:1-3:32" },
  "07-11": { nt: "Acts 18:1-18:22", ot: "Neh. 4:1-7:4" },
  "07-12": { nt: "Acts 18:23-19:20", ot: "Neh. 7:5-8:18" },
  "07-13": { nt: "Acts 19:21-19:41", ot: "Neh. 9:1-10:39" },
  "07-14": { nt: "Acts 20:1-20:12", ot: "Neh. 11:1-12:26" },
  "07-15": { nt: "Acts 20:13-20:38", ot: "Neh. 12:27-13:31" },
  "07-16": { nt: "Acts 21:1-21:17", ot: "Esth. 1:1-2:23" },
  "07-17": { nt: "Acts 21:18-21:39", ot: "Esth. 3:1-8:2" },
  "07-18": { nt: "Acts 21:40-22:29", ot: "Esth. 8:3-10:3" },
  "07-19": { nt: "Acts 22:30-23:15", ot: "Job 1:1-3:26" },
  "07-20": { nt: "Acts 23:16-23:35", ot: "Job 4:1-7:21" },
  "07-21": { nt: "Acts 24:1-24:27", ot: "Job 8:1-11:20" },
  "07-22": { nt: "Acts 25:1-25:27", ot: "Job 12:1-14:22" },
  "07-23": { nt: "Acts 26:1-26:32", ot: "Job 15:1-17:16" },
  "07-24": { nt: "Acts 27:1-27:26", ot: "Job 18:1-20:29" },
  "07-25": { nt: "Acts 27:27-27:44", ot: "Job 21:1-22:30" },
  "07-26": { nt: "Acts 28:1-28:10", ot: "Job 23:1-25:6" },
  "07-27": { nt: "Acts 28:11-28:31", ot: "Job 26:1-29:25" },
  "07-28": { nt: "Rom. 1:1-1:17", ot: "Job 30:1-32:1" },
  "07-29": { nt: "Rom. 1:18-1:32", ot: "Old Testament -Job 32:2-34:37" },
  "07-30": { nt: "Rom. 2:1-2:16", ot: "Job 35:1-37:24" },
  "07-31": { nt: "Rom. 2:17-3:8", ot: "Job 38:1-40:14" },
  "08-01": { nt: "Rom. 3:9-3:20", ot: "Job 40:15-42:17" },
  "08-02": { nt: "Rom. 3:21-4:25", ot: "Psa. 1:1-6:10" },
  "08-03": { nt: "Rom. 5:1-5:11", ot: "Psa. 7:1-10:18" },
  "08-04": { nt: "Rom. 5:12-5:21", ot: "Psa. 11:1-17:15" },
  "08-05": { nt: "Rom. 6:1-6:23", ot: "Psa. 18:1-20:9" },
  "08-06": { nt: "Rom. 7:1-7:25", ot: "Psa. 21:1-25:22" },
  "08-07": { nt: "Rom. 8:1-8:13", ot: "Psa. 26:1-30:12" },
  "08-08": { nt: "Rom. 8:14-8:39", ot: "Psa. 31:1-33:22" },
  "08-09": { nt: "Rom. 9:1-9:18", ot: "Psa. 34:1-36:12" },
  "08-10": { nt: "Rom. 9:19-10:3", ot: "Psa. 37:1-38:22" },
  "08-11": { nt: "Rom. 10:4-10:21", ot: "Psa. 39:1-41:13" },
  "08-12": { nt: "Rom. 11:1-11:10", ot: "Psa. 42:1-45:17" },
  "08-13": { nt: "Rom. 11:11-11:36", ot: "Psa. 46:1-49:20" },
  "08-14": { nt: "Rom. 12:1-12:21", ot: "Psa. 50:1-52:9" },
  "08-15": { nt: "Rom. 13:1-13:14", ot: "Psa. 53:1-58:11" },
  "08-16": { nt: "Rom. 14:1-15:13", ot: "Psa. 59:1-64:10" },
  "08-17": { nt: "Rom. 15:14-16:27", ot: "Psa. 65:1-68:35" },
  "08-18": { nt: "1 Cor. 1:1-1:9", ot: "Psa. 69:1-72:20" },
  "08-19": { nt: "1 Cor. 1:10-1:31", ot: "Psa. 73:1-77:20" },
  "08-20": { nt: "1 Cor. 2:1-2:16", ot: "Psa. 78:1-79:13" },
  "08-21": { nt: "1 Cor. 3:1-3:23", ot: "Psa. 80:1-89:52" },
  "08-22": { nt: "1 Cor. 4:1-4:21", ot: "Psa. 90:1-97:12" },
  "08-23": { nt: "1 Cor. 5:1-5:13", ot: "Psa. 98:1-102:28" },
  "08-24": { nt: "1 Cor. 6:1-6:20", ot: "Psa. 103:1-106:48" },
  "08-25": { nt: "1 Cor. 7:1-7:24", ot: "Psa. 107:1-110:7" },
  "08-26": { nt: "1 Cor. 7:25-7:40", ot: "Psa. 111:1-118:29" },
  "08-27": { nt: "1 Cor. 8:1-8:13", ot: "Psa. 119:1-119:88" },
  "08-28": { nt: "1 Cor. 9:1-9:27", ot: "Psa. 119:89-119:176" },
  "08-29": { nt: "1 Cor. 10:1-10:33", ot: "Psa. 120:1-131:3" },
  "08-30": { nt: "1 Cor. 11:1-11:34", ot: "Psa. 132:1-134:3" },
  "08-31": { nt: "1 Cor. 12:1-12:31", ot: "Psa. 135:1-139:24" },
  "09-01": { nt: "1 Cor. 13:1-13:13", ot: "Psa. 140:1-144:15" },
  "09-02": { nt: "1 Cor. 14:1-14:25", ot: "Psa. 145:1-150:6" },
  "09-03": { nt: "1 Cor. 14:26-14:40", ot: "Prov. 1:1-2:22" },
  "09-04": { nt: "1 Cor. 15:1-15:28", ot: "Prov. 3:1-5:23" },
  "09-05": { nt: "1 Cor. 15:29-15:58", ot: "Prov. 6:1-7:27" },
  "09-06": { nt: "1 Cor. 16:1-16:24", ot: "Prov. 8:1-9:18" },
  "09-07": { nt: "2 Cor. 1:1-2:11", ot: "Prov. 10:1-11:31" },
  "09-08": { nt: "2 Cor. 2:12-3:11", ot: "Prov. 12:1-13:25" },
  "09-09": { nt: "2 Cor. 3:12-4:6", ot: "Prov. 14:1-15:33" },
  "09-10": { nt: "2 Cor. 4:7-5:15", ot: "Prov. 16:1-17:28" },
  "09-11": { nt: "2 Cor. 5:16-6:13", ot: "Prov. 18:1-19:29" },
  "09-12": { nt: "2 Cor. 6:14-7:16", ot: "Prov. 20:1-21:31" },
  "09-13": { nt: "2 Cor. 8:1-8:24", ot: "Prov. 22:1-23:35" },
  "09-14": { nt: "2 Cor. 9:1-9:15", ot: "Prov. 24:1-24:34" },
  "09-15": { nt: "2 Cor. 10:1-10:18", ot: "Prov. 25:1-26:28" },
  "09-16": { nt: "2 Cor. 11:1-11:33", ot: "Prov. 27:1-28:28" },
  "09-17": { nt: "2 Cor. 12:1-12:18", ot: "Prov. 29:1-29:27" },
  "09-18": { nt: "2 Cor. 12:19-13:14", ot: "Prov. 30:1-31:31" },
  "09-19": { nt: "Gal. 1:1-2:10", ot: "Eccl. 1:1-3:15" },
  "09-20": { nt: "Gal. 2:11-2:21", ot: "Eccl. 3:16-5:7" },
  "09-21": { nt: "Gal. 3:1-3:29", ot: "Eccl. 5:8-6:12" },
  "09-22": { nt: "Gal. 4:1-4:31", ot: "Eccl. 7:1-11:8" },
  "09-23": { nt: "Gal. 5:1-5:15", ot: "Eccl. 11:9-12:14" },
  "09-24": { nt: "Gal. 5:16-6:18", ot: "S.S. 1:1-4:15" },
  "09-25": { nt: "Eph. 1:1-1:23", ot: "S.S. 4:16-8:14" },
  "09-26": { nt: "Eph. 2:1-2:22", ot: "Isa. 1:1-5:30" },
  "09-27": { nt: "Eph. 3:1-3:21", ot: "Isa. 6:1-9:7" },
  "09-28": { nt: "Eph. 4:1-4:16", ot: "Isa. 9:8-12:6" },
  "09-29": { nt: "Eph. 4:17-5:21", ot: "Isa. 13:1-16:14" },
  "09-30": { nt: "Eph. 5:22-6:24", ot: "Isa. 17:1-20:6" },
  "10-01": { nt: "Phil. 1:1-1:18", ot: "Isa. 21:1-23:18" },
  "10-02": { nt: "Phil. 1:19-1:30", ot: "Isa. 24:1-27:13" },
  "10-03": { nt: "Phil. 2:1-2:30", ot: "Isa. 28:1-29:24" },
  "10-04": { nt: "Phil. 3:1-3:21", ot: "Isa. 30:1-31:9" },
  "10-05": { nt: "Phil. 4:1-4:23", ot: "Isa. 32:1-35:10" },
  "10-06": { nt: "Col. 1:1-1:14", ot: "Isa. 36:1-38:22" },
  "10-07": { nt: "Col. 1:15-1:29", ot: "Isa. 39:1-40:31" },
  "10-08": { nt: "Col. 2:1-2:23", ot: "Isa. 41:1-42:25" },
  "10-09": { nt: "Col. 3:1-3:11", ot: "Isa. 43:1-45:25" },
  "10-10": { nt: "Col. 3:12-4:6", ot: "Isa. 46:1-49:26" },
  "10-11": { nt: "Col. 4:7-4:18", ot: "Isa. 50:1-52:12" },
  "10-12": { nt: "1 Thes. 1:1-1:10", ot: "Isa. 52:13-55:13" },
  "10-13": { nt: "1 Thes. 2:1-2:20", ot: "Isa. 56:1-58:14" },
  "10-14": { nt: "1 Thes. 3:1-3:13", ot: "Isa. 59:1-61:3" },
  "10-15": { nt: "1 Thes. 4:1-4:18", ot: "Isa. 61:4-63:19" },
  "10-16": { nt: "1 Thes. 5:1-5:28", ot: "Isa. 64:1-66:24" },
  "10-17": { nt: "2 Thes. 1:1-1:12", ot: "Jer. 1:1-4:2" },
  "10-18": { nt: "2 Thes. 2:1-3:5", ot: "Jer. 4:3-6:30" },
  "10-19": { nt: "2 Thes. 3:6-3:18", ot: "Jer. 7:1-8:22" },
  "10-20": { nt: "1 Tim. 1:1-1:20", ot: "Jer. 9:1-10:25" },
  "10-21": { nt: "1 Tim. 2:1-2:15", ot: "Jer. 11:1-13:27" },
  "10-22": { nt: "1 Tim. 3:1-3:16", ot: "Jer. 14:1-15:9" },
  "10-23": { nt: "1 Tim. 4:1-4:16", ot: "Jer. 15:10-17:27" },
  "10-24": { nt: "1 Tim. 5:1-5:25", ot: "Jer. 18:1-20:18" },
  "10-25": { nt: "1 Tim. 6:1-6:21", ot: "Jer. 21:1-23:8" },
  "10-26": { nt: "2 Tim. 1:1-1:18", ot: "Jer. 23:9-24:10" },
  "10-27": { nt: "2 Tim. 2:1-2:26", ot: "Jer. 25:1-26:24" },
  "10-28": { nt: "2 Tim. 3:1-3:17", ot: "Jer. 27:1-28:17" },
  "10-29": { nt: "2 Tim. 4:1-4:22", ot: "Jer. 29:1-29:32" },
  "10-30": { nt: "Titus 1:1-1:16", ot: "Jer. 30:1-31:40" },
  "10-31": { nt: "Titus 2:1-2:15", ot: "Jer. 32:1-33:26" },
  "11-01": { nt: "Titus 3:1-3:15", ot: "Jer. 34:1-35:19" },
  "11-02": { nt: "Philem. 1:1-1:25", ot: "Jer. 36:1-38:28" },
  "11-03": { nt: "Heb. 1:1-1:14", ot: "Jer. 39:1-39:18" },
  "11-04": { nt: "Heb. 2:1-2:18", ot: "Jer. 40:1-41:18" },
  "11-05": { nt: "Heb. 3:1-4:13", ot: "Jer. 42:1-44:30" },
  "11-06": { nt: "Heb. 4:14-5:10", ot: "Jer. 45:1-47:7" },
  "11-07": { nt: "Heb. 5:11-6:20", ot: "Jer. 48:1-49:6" },
  "11-08": { nt: "Heb. 7:1-7:28", ot: "Jer. 49:7-49:39" },
  "11-09": { nt: "Heb. 8:1-8:13", ot: "Jer. 50:1-51:64" },
  "11-10": { nt: "Heb. 9:1-10:18", ot: "Jer. 52:1-52:34" },
  "11-11": { nt: "Heb. 10:19-10:39", ot: "Lam. 1:1-2:22" },
  "11-12": { nt: "Heb. 11:1-11:40", ot: "Lam. 3:1-3:66" },
  "11-13": { nt: "Heb. 12:1-12:29", ot: "Lam. 4:1-5:22" },
  "11-14": { nt: "Heb. 13:1-13:25", ot: "Ezek. 1:1-3:27" },
  "11-15": { nt: "James 1:1-1:12", ot: "Ezek. 4:1-7:27" },
  "11-16": { nt: "James 1:13-1:27", ot: "Ezek. 8:1-11:25" },
  "11-17": { nt: "James 2:1-2:13", ot: "Ezek. 12:1-14:23" },
  "11-18": { nt: "James 2:14-2:26", ot: "Ezek. 15:1-16:63" },
  "11-19": { nt: "James 3:1-3:18", ot: "Ezek. 17:1-19:14" },
  "11-20": { nt: "James 4:1-5:6", ot: "Ezek. 20:1-20:44" },
  "11-21": { nt: "James 5:7-5:20", ot: "Ezek. 20:45-22:31" },
  "11-22": { nt: "1 Pet. 1:1-1:12", ot: "Ezek. 23:1-24:27" },
  "11-23": { nt: "1 Pet. 1:13-1:25", ot: "Ezek. 25:1-28:19" },
  "11-24": { nt: "1 Pet. 2:1-2:10", ot: "Ezek. 28:20-32:32" },
  "11-25": { nt: "1 Pet. 2:11-2:25", ot: "Ezek. 33:1-34:10" },
  "11-26": { nt: "1 Pet. 3:1-3:13", ot: "Ezek. 34:11-35:15" },
  "11-27": { nt: "1 Pet. 3:14-4:19", ot: "Ezek. 36:1-36:38" },
  "11-28": { nt: "1 Pet. 5:1-5:14", ot: "Ezek. 37:1-37:28" },
  "11-29": { nt: "2 Pet. 1:1-1:11", ot: "Ezek. 38:1-39:29" },
  "11-30": { nt: "2 Pet. 1:12-1:21", ot: "Ezek. 40:1-41:26" },
  "12-01": { nt: "2 Pet. 2:1-2:22", ot: "Ezek. 42:1-43:27" },
  "12-02": { nt: "2 Pet. 3:1-3:18", ot: "Ezek. 44:1-45:8" },
  "12-03": { nt: "1 John 1:1-2:11", ot: "Ezek. 45:9-46:24" },
  "12-04": { nt: "1 John 2:12-3:10", ot: "Ezek. 47:1-48:35" },
  "12-05": { nt: "1 John 3:11-3:24", ot: "Dan. 1:1-2:49" },
  "12-06": { nt: "1 John 4:1-5:3", ot: "Dan. 3:1-4:37" },
  "12-07": { nt: "1 John 5:4-5:21", ot: "Dan. 5:1-6:28" },
  "12-08": { nt: "2 John 1:1-1:13", ot: "Dan. 7:1-8:27" },
  "12-09": { nt: "3 John 1:1-1:14", ot: "Dan. 9:1-11:1" },
  "12-10": { nt: "Jude 1:1-1:25", ot: "Dan. 11:2-12:13" },
  "12-11": { nt: "Rev. 1:1-1:20", ot: "Hosea 1:1-3:5" },
  "12-12": { nt: "Rev. 2:1-2:29", ot: "Hosea 4:1-7:16" },
  "12-13": { nt: "Rev. 3:1-3:22", ot: "Hosea 8:1-10:15" },
  "12-14": { nt: "Rev. 4:1-5:14", ot: "Hosea 11:1-14:9" },
  "12-15": { nt: "Rev. 6:1-6:17", ot: "Joel 1:1-3:21" },
  "12-16": { nt: "Rev. 7:1-7:17", ot: "Amos 1:1-2:16" },
  "12-17": { nt: "Rev. 8:1-8:12", ot: "Amos 3:1-5:27" },
  "12-18": { nt: "Rev. 8:13-9:21", ot: "Amos 6:1-9:15" },
  "12-19": { nt: "Rev. 10:1-10:11", ot: "Obad. 1:1-1:21" },
  "12-20": { nt: "Rev. 11:1-11:19", ot: "Jonah 1:1-4:11" },
  "12-21": { nt: "Rev. 12:1-12:18", ot: "Micah 1:1-5:15" },
  "12-22": { nt: "Rev. 13:1-13:18", ot: "Micah 6:1-7:20" },
  "12-23": { nt: "Rev. 14:1-14:20", ot: "Nahum 1:1-3:19" },
  "12-24": { nt: "Rev. 15:1-16:21", ot: "Hab. 1:1-3:19" },
  "12-25": { nt: "Rev. 17:1-17:18", ot: "Zeph. 1:1-3:20" },
  "12-26": { nt: "Rev. 18:1-18:24", ot: "Hag. 1:1-2:23" },
  "12-27": { nt: "Rev. 19:1-19:21", ot: "Zech. 1:1-6:8" },
  "12-28": { nt: "Rev. 20:1-20:15", ot: "Zech. 6:9-9:17" },
  "12-29": { nt: "Rev. 21:1-21:27", ot: "Zech. 10:1-14:21" },
  "12-30": { nt: "Rev. 22:1-22:21", ot: "Mal. 1:1-4:6" },
  "12-31": { nt: "Rest", ot: "Rest" },
};

export function getTodayReading() {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const key = `${mm}-${dd}`;
  return schedule[key] || { nt: 'Rest day', ot: 'Rest day' };
}

export function getReadingForDate(dateStr) {
  const key = dateStr ? dateStr.slice(5) : null;
  return (key && schedule[key]) || { nt: 'Rest day', ot: 'Rest day' };
}

export default schedule;